@use 'src/global/variables.scss' as var;
@use 'src/global/mixins/icon' as icon;

c-suggestions {
  text-align: center;
  align-content: center;
  list-style-type: none;

  .suggestion-button,
  .suggestion-link {
    font-size: 16px;
    background: var.$text-color-light;
    color: var.$primary-color;
    border: 1px solid currentColor;
    box-shadow: var.$message-screen-elements-box-shadow;
    cursor: pointer;
    max-width: calc(100% - 24px);

    &.small-suggestion-button,
    &.small-suggestion-link {
      padding: 8px 12px;
      margin: 2px;
      border-radius: 10px;
      border: 1px solid transparent;
      background: #D9E1ED;
    }

    &.big-suggestion-button,
    &.big-suggestion-link {
      padding: 8px 16px;
      width: calc(100% - 24px);
      border-width: 2px;
      font-weight: bold;
      border-radius: 5px;
    }

    // Firefox on Windows displays an additional border around focused elements
    &::-moz-focus-inner {
      border: 0;
    }
    &:hover,
    &:focus {
      outline: none;
      box-shadow: 0 0 0 3px var.$focus-color;
      border-color: var.$focus-color;
    }
  }

  .suggestion-link {
    display: inline-block;
    box-sizing: border-box;
    text-decoration: none;
    text-align: center;

    &.small-suggestion-link {
      width: max-content;
    }
  }

  .link-icon {
    margin-left: 0.8rem;
    &:before {
      font-size: 1.1rem;
      @include icon.icon();
      color: var.$primary-color;
      content: '\f149';
    }
  }
}
